<template lang="pug">
.section
	.section-header
		h1 {{ $t("ui.daily_pnl_operator") }}
	.section-body
		.row
			.col-12
				.card.mb-0
					.card-header
						.row.w-100
							.form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1(v-if="!isOperator")
								b-input-group(size="sm")
									b-input-group-text(slot="prepend")
										i.fa.fa-user
									DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getWinLose(true)" size="sm")
							.form-group.col-md-12.col-lg-12.col-xl-5.col-12.mb-1
								DateRangePicker(:value="dateRange" @update="getData")
							.form-group.col-12.mb-1
								SubmitButton(
									icon="fa fa-search"
									:loading="loading"
									:text="$t('ui.search')"
									type="button"
									@click="getWinLose(true)"
									variant="primary"
									size="sm"
								).mr-2
								jsonToExcel(v-if="winloseList.length > 0" mode="DailyPnlOperator" tbl="tblList" tbl2="tblList2" :date="dateRange" btnTxt="export_excel" type="1" :loading2="loading").mr-2
								dailyPnlOperatorExport(v-if="winloseList.length > 0" :tbl="ledgerList" :tbl2="winloseList" :totalTbl="grandTotalList" tblId="tblList" tblId2="tblList2")
					.card-body
						.row
							.col-12(style="max-height: 70vh; overflow: hidden;")
								.clusterize-scroll.table-responsive
									table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
										thead.thead-light
											tr
												th.text-center(width="12%")
													span(:title="$t('ui.share_operator')") {{ $t('ui.share_operator') }}
												//- th.text-right(width="10%")
												//- 	span(:title="$t('ui.deposit_amount')") {{ $t('ui.deposit_amount') }}
												//- th.text-right(width="10%")
												//- 	span(:title="$t('ui.withdrawal_amount')") {{ $t('ui.withdrawal_amount') }}
												th.text-center(width="10%")
													span(:title="$t('ui.bonus_amount')") {{ $t('ui.bonus_amount') }}
												th.text-center(width="10%")
													span(:title="$t('ui.adjustment_amount')") {{ $t('ui.adjustment_amount') }}
												th.text-center(width="10%")
													span(:title="$t('ui.pnl')") {{ $t('ui.pnl') }}
										tbody.clusterize-content
											tr(v-if="ledgerList.length == 0")
												td(colspan="6").text-center
													span {{ $t('message.no_data_available') }}
											tr(v-for="(item, index) in ledgerList")
												td.text-center
													span.font-weight-bold(:class="$helpers.fontClassName(item.share_operator)" :title="$n(item.share_operator, 'currency')") {{ $n(item.share_operator, 'currency') }}
												//- td.text-right
												//- 	span.font-weight-bold(:class="$helpers.fontClassName(item.deposit_amount)" :title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
												//- td.text-right
												//- 	span.font-weight-bold(:class="$helpers.fontClassName(item.withdrawal_amount)" :title="$n(item.withdrawal_amount, 'currency')") {{ $n(item.withdrawal_amount, 'currency') }}
												td.text-center
													span.font-weight-bold(:class="$helpers.fontClassName(item.bonus_amount)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
												td.text-center
													span.font-weight-bold(:class="$helpers.fontClassName(item.adjustment_amount)" :title="$n(item.adjustment_amount, 'currency')") {{ $n(item.adjustment_amount, 'currency') }}
												td.text-center
													span.font-weight-bold(:class="$helpers.fontClassName(item.pnl)" :title="$n(item.pnl, 'currency')") {{ $n(item.pnl, 'currency') }}
							.col-12(style="max-height: 70vh; overflow: hidden;")
								.clusterize-scroll.table-responsive
									table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList2
										thead.thead-light
											tr
												th.text-center(width="3%")
													span #
												th(width="8%")
													span(:title="$t('ui.category')") {{ $t('ui.category') }}
												th(width="10%")
													span(:title="$t('ui.provider_code')") {{ $t('ui.provider_code') }}
												th(width="15%")
													span(:title="$t('ui.provider_name')") {{ $t('ui.provider_name') }}
												th.text-center(width="5%" @click="sortOrder('pt')")
													span(:title="$t('ui.pt')") {{ $t('ui.pt') }} (%)
													.float-right
														i(:class="changeSortKey('pt')")
												th.text-center(width="5%" @click="sortOrder('pt_on')")
													span(:title="$t('ui.pt_on')") {{ $t('ui.pt_on') }}
													.float-right
														i(:class="changeSortKey('pt_on')")
												th.text-right(width="12%" @click="sortOrder('share_company')")
													span(:title="$t('ui.share_company')") {{ $t('ui.share_company') }}
													.float-right
														i(:class="changeSortKey('share_company')")
												th.text-right(width="12%" @click="sortOrder('share_operator')")
													span(:title="$t('ui.share_operator')") {{ $t('ui.share_operator') }}
													.float-right
														i(:class="changeSortKey('share_operator')")
												th.text-right(width="10%" @click="sortOrder('winlose')")
													span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
													.float-right
														i(:class="changeSortKey('winlose')")
												th.text-right(width="10%" @click="sortOrder('turnover')")
													span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
													.float-right
														i(:class="changeSortKey('turnover')")
												th.text-right(width="10%" @click="sortOrder('valid_turnover')")
													span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
													.float-right
														i(:class="changeSortKey('valid_turnover')")
										tbody.clusterize-content
											tr(v-if="winloseList.length == 0")
												td(colspan="11").text-center
													span {{ $t('message.no_data_available') }}
											tr(v-for="(item, index) in winloseList")
												td.text-center
													span(:title="(index + 1)") {{ index + 1 }}
												td
													span(:title="item.category") {{ item.category }}
												td
													span(:title="item.provider_code") {{ item.provider_code }}
												td
													span(:title="item.provider_name" v-if="item.provider_name != null") {{ item.provider_name }}
													div.text-center(v-else) -
												td.text-center.font-weight-bold
													span(:title="$n(item.pt)") {{ $n(item.pt) }}
												td.text-center
													span(:title="item.pt_on" v-if="item.pt_on != null") {{ item.pt_on }}
													span(v-else) -

												td.text-right
													span.font-weight-bold(:class="$helpers.fontClassName(item.share_company)" :title="$n(item.share_company, 'currency')") {{ $n(item.share_company, 'currency') }}
												td.text-right
													span.font-weight-bold(:class="$helpers.fontClassName(item.share_operator)" :title="$n(item.share_operator, 'currency')") {{ $n(item.share_operator, 'currency') }}
												td.text-right
													span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
												td.text-right
													span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
												td.text-right
													span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}

											tr(v-if="showTotal")
												td.text-right(colspan="6")
													span {{ $t("ui.grand_total") }}
												td.text-right(colspan="1")
													span.font-weight-bold(:class="$helpers.fontClassName(grandTotalShareCompany)" :title="$n(grandTotalShareCompany, 'currency')") {{ $n(grandTotalShareCompany, 'currency') }}
												td.text-right
													span.font-weight-bold(:class="$helpers.fontClassName(grandTotalShareOperator)" :title="$n(grandTotalShareOperator, 'currency')") {{ $n(grandTotalShareOperator, 'currency') }}
												td.text-right
													span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
												td.text-right
													span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
												td.text-right
													span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import dailyPnlOperatorExport from "@/components/report/dailyPnlOperatorExportFull.vue";

export default {
	components: {
		SubmitButton,
		DebounceInput,
		DateRangePicker,
		jsonToExcel,
		dailyPnlOperatorExport
	},
	data: () => ({
		loading: false,
		grandTotalList: [],
		winloseList: [],
		ledgerList: [],
		searchID: "",
		grandTotalWinLose: 0,
		grandTotalTurnover: 0,
		grandTotalValidTurnover: 0,
		grandTotalShareCompany: 0,
		grandTotalShareOperator: 0,
		showTotal: false,
		feedback: {
				success: false,
				status: errorTags.request.failed
		},
		dateRange: {
				startDate: null,
				endDate: null
		},
		locale: {
				format: "YYYY-MM-DD",
				useCurrent: true
		},
		sortKey: "account_id",
		sortType: "asc",
	}),
	computed: {
		isOperator() {
			return [2].includes(this.$store.getters.accountType);
		},
		accountID() {
			return this.$store.getters.accountId;
		},
		getAuthorityRole() {
			if (this.$store.getters.authorityRole)
				return this.$store.getters.authorityRole;

			return '';
		},
	},
	mounted: function () {
		if (this.$store.getters.sessionToken) {
			if (this.isOperator) {
				this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
				this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
				this.searchID = this.accountID
				this.getWinLose(true);
			} else {
				if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
					this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
					this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
				} else {
					this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
					this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
				}

				if (this.$store.getters.reportStatement.operator_id != null)
					this.searchID = this.$store.getters.reportStatement.operator_id;

				if (this.searchID.trim() != '')
					this.getWinLose();
			}
		}
	},
	methods: {
		sortOrder(key) {
			if (this.sortKey == key)
				this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
			else {
				this.sortKey = key;
				this.sortType = 'asc';
			}

			this.getWinLose(true);
		},
		changeSortKey(key) {
			if (this.sortKey != key)
				return 'fas fa-sort';
			else if (this.sortKey == key && this.sortType == 'asc')
				return 'fa fa-sort-up';
			else if (this.sortKey == key && this.sortType == 'desc')
				return 'fa fa-sort-down';
		},
		checkDateRange() {
			if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
				return false;
			else
				return true;
		},
		getData(currentValue) {
			this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
			this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
			this.currentPage = 1;
			this.getWinLose();
		},
		setReportStatementParam: function () {
			var json = {
				operator_id: this.searchID,
				member_id: this.$store.getters.reportStatement.member_id,
				start_date: this.dateRange.startDate,
				end_date: this.dateRange.endDate
			};
			this.$store.dispatch("user/setReportStatementParam", json);
		},
		getWinLose: function() {
			if (this.checkDateRange()) {
				this.setReportStatementParam();
				if (this.searchID.trim() == '') {
					this.clearTotal();
					this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.operatorIdRequired"), "error");
					return;
				}

				let url = config.dailyPnlOperatorUrl();

				var json = {
					action_by: this.$store.getters.loginId,
					auth_token: this.$store.getters.sessionToken,
					operator_id: this.searchID,
					start_date: this.dateRange.startDate,
					end_date: this.dateRange.endDate,
					sort_type: this.sortType,
					sort_key: this.sortKey,
					page_number: 1,
					page_size: 1000
				};

				this.loading = true;
				this.$http.post(url, json).then(
					function (response) {
						this.clearTotal()
						this.loading = false;
						// Success
						try {
							if (response) {
								this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

								this.feedback.status = response.data.statusdesc;
								if (this.feedback.success == true) {
									if (response.data.ds.winlose != null && response.data.ds.winlose.length > 0) {
										this.showTotal = true
										if (response.data.ds.grand_total.length > 0) {
											this.grandTotalWinLose = response.data.ds.grand_total[0]["winlose"];
											this.grandTotalTurnover = response.data.ds.grand_total[0]["turnover"];
											this.grandTotalValidTurnover = response.data.ds.grand_total[0]["valid_turnover"];
											this.grandTotalShareCompany = response.data.ds.grand_total[0]["share_company"];
											this.grandTotalShareOperator = response.data.ds.grand_total[0]["share_operator"];
										}

										this.grandTotalList = response.data.ds.grand_total
										this.winloseList = response.data.ds.winlose
										this.ledgerList = response.data.ds.ledger
									} else {
										this.clearTotal()
									}
								} else {
									this.clearTotal()
									if (this.feedback.status != 'permission_denied') {
										if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
									}
									else {
										this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
									}
								}
							}
						} catch (error) {
							this.feedback.success = false;
							this.feedback.status = errorTags.request.failed;
							this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
						}
					},
					function (response) {
						this.loading = false;
						// Error
						this.feedback.success = false;
						this.feedback.status = errorTags.request.failed;
						this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
					}
				);
			} else {
				this.clearTotal();
				this.winloseList = [];
				this.ledgerList = [];
				this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
			}
		},
		clearTotal() {
			this.showTotal = false;
			this.winloseList = []
			this.ledgerList = []
			this.grandTotalWinLose = 0
			this.grandTotalTurnover = 0
			this.grandTotalValidTurnover = 0
			this.grandTotalShareCompany = 0
			this.grandTotalShareOperator = 0
		},
		handleFailed: function (tag, status) {
			this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
		}
	}
};
</script>